<file-list [template]="fileItem" [files]="files" [fileEl]="fileEl" [removable]="!!removable"></file-list>
<ng-template #fileItem let-file="file">
  <div class="file-item" [title]="file.name">
    <img [src]="file.name | fileIcon" class="file-item__image">
    <div class="file-item__name text-primary" (click)="viewAttachment(file, $event)">{{file.name}}</div>
    <i *ngIf="removable" (click)="removeAttachment(file, template)"
       class="fa fa-trash file-item__remove text-danger"></i>
  </div>
</ng-template>
<ng-template #template>
  <div class="modal-header">
    <h4 class="modal-title pull-left">Đính kèm</h4>
    <button type="button" class="close pull-right" aria-label="Close" (click)="modalRef.hide()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body" [innerHTML]="confirmMessage"></div>
  <div class="modal-footer">
    <button type="button" class="btn btn-sm btn-danger" (click)="removeFile()"><i class="fa fa-trash"></i> Xóa</button>
    <button type="button" class="btn btn-sm btn-secondary" (click)="modalRef.hide()"><i class="fa fa-times"></i> Đóng</button>
  </div>
</ng-template>
